import React from "react";
import ClickToFlyHubContent from "../components/click-to-fly/click-to-fly-hub-content";

const ClickToFlyHub = () => {
  return <ClickToFlyHubContent />;
};

export default ClickToFlyHub;











